import React from "react";
import ReactApexChart from "react-apexcharts";

const ApexLineAchievement = ({ data = [] }) => {
  const categories = data.map((item) => item.month); // أسماء الشهور
  const seriesData = data.map((item) => item.achievement_percentage); // نسب الإنجاز

  const chartOptions = {
    chart: {
      height: 350,
      type: "area",
      toolbar: { show: false },
    },
    dataLabels: { enabled: false },
    stroke: {
      width: [3],
      colors: ["#1abc9c"],
      curve: "smooth",
    },
    xaxis: {
      categories,
      labels: {
        rotate: -45,
        style: { fontFamily: "Cairo" },
      },
    },
    colors: ["#1abc9c"],
    markers: {
      size: 5,
      strokeWidth: 3,
      strokeColors: "#1abc9c",
      colors: ["#fff"],
      hover: { size: 8 },
    },
    yaxis: {
      title: { text: "نسبة الإنجاز (%)", style: { fontFamily: "Cairo" } },
      labels: {
        formatter: (val) => `${val}%`,
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val}%`,
      },
    },
  };

  const series = [
    {
      name: "نسبة الإنجاز",
      data: seriesData,
    },
  ];

  return (
    <div className="card p-3">
      <h5 className="text-center mb-3" style={{ fontFamily: "Cairo", fontWeight: "600" }}>
        معدل الإنجاز خلال آخر 12 شهر
      </h5>
      <ReactApexChart options={chartOptions} series={series} type="area" height={350} />
    </div>
  );
};

export default ApexLineAchievement;
